<template>
	<div v-show="show_tan" class="pre_tan">
		<span class="pre_tan_bg" @click="closeshow"></span>
		<div class="pre_tan_conten">
			<span class="pre_tan_close">
				<img src="../../assets/image/shan1.png" @click="closeshow" />
			</span>
			<div class="pre_upload">
				<div class="pre_leve_one">
					<h3>{{title}}</h3>
					<div class="content_edit">
						<div class="content_edit_item">
							<button class="pre_btn_ok" @click="refresh_data()">
								刷新
							</button>
							<button class="pre_btn_ok" @click="refresh_data('new')">
								清空
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_add')">
								增加
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_upd')">
								修改
							</button>
							<button class="pre_btn_ok btn_del" @click="fun_upd('_del')">
								删除
							</button>
						</div>
					</div>


				</div>
				<div class="pre_leve_two">
					<!-- 这里放相关内容-->
					<div class="content_edit" v-loading="element_loading" element-loading-text="拼命加载中......"
						element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
						<div class="content_edit_item" v-for="(item,index) in parm" :key="index">
							<div v-if="item.type == 'readonly'">
								<label>{{item.name}}:</label><input :id="item.key" class="input_readonly" type="text"
									:class="[item.class==''?'short0':item.class]" v-model="item.val"
									readonly="readonly" />
							</div>
							<div v-else>
								<label>{{item.name}}:</label>
								<input type="text" class="long2" v-model="item.val" @keyup.enter="fun_upd('_add')" />
								<em>*</em>
							</div>

						</div>
					</div>
					<!-- 通配表格设置 -->
					<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
						:pre_post_upd="upd_json">
						<!-- 设定标题  -->
						<template slot="tab_title">
							<tr class="tab_header">
								<td>ID</td>
								<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
							</tr>
						</template>
						<template slot="tab_tr" slot-scope="user">
							<tr @click="sel_row(user.item)">
								<!-- <a href="#"> -->
								<td v-for="(d,index) in user.item" :key="index"><a href="#">{{d.val}}</a></td>
								<!-- </a> -->
							</tr>
						</template>
						<!-- 构建新增模板 -->
						<template slot="tab_addorupdate">

						</template>
					</pre-table>


				</div>

				<!-- 弹出向导层 end-->
			</div>
		</div>

	</div>
</template>

<script>
	/*
名称：通用少字段操作,不支持下拉菜单
日期：2020-11-29
作者：hj
目标：
使用 props 控制，会互相干扰
所以用  ref
基本操作+编辑区+表格
*/

	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		name: "pre_tan_one",
		components: {
			"pre-table": () => import("./pre_table_nokey2.vue")
		},
		data() {
			return {
				element_loading: false,
				show_tan: false,
				load_url: '',
				load_json: '',
				upd_json: '',
				bak_data: '', //防止重复操作记录
				nowpage: '1',
				title: '未设置标题',
				action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',

				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: ''

			};
		},
		methods: {
			load_data: function(d) {
				// console.log(this.post_item);

				// this.closeshow();
				this.open_show();
				let r = JSON.parse(d);
				// console.log(r);
				this.action = r.action;
				this.title = r.title;
				this.parm = r.parm;
				this.parm_th = r.parm_th;
				// console.log(this.parm);
				if (typeof r.keyword == "undefined" || r.keyword == null || r.keyword == "") {
					console.log('默认查询关键字0' + r.keyword);
				} else {
					console.log('默认查询关键字1' + r.keyword);
					this.kw1 = r.keyword;
				}


				let rd = (Math.random() + '').substring(0, 8);
				this.load_url = api.http_method;
				this.load_json = Method_EasySelect('data_exp_' + this.action, this.kw1, '', '', rd);
			},
			open_show: function() {
				this.show_tan = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pre_tan_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pre_tan_bg").fadeIn("3000");
				$(".pre_tan_conten").fadeIn("3000");
			},
			closeshow: function() {
				this.dataclear();
				this.show_tan = false;
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");
				// this.dataclear();
				// this.$emit('tan-up', 'tan-up', this.file_ok);
			},

			refresh_data: function(type) {
				console.log(this.parm);
				
				// console.log(this.kw1 + ' ++ ' + this.kw2);
				let r = (Math.random() + '').substring(0, 8);
				this.load_json = Method_EasySelect('data_exp_' + this.action, this.kw1, '','', r);
			},
			sel_row: function(item) {
				// console.log(item);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性

				for (let i = 0; i < item.length; i++) {
					if (item[i].key == 'id') {
						this.row_id = item[i].val;
					} else if (item[i].key == 'sys_date') {
						this.sys_date = item[i].val;
					} else {
						for (let j = 0; j < this.parm.length; j++) {
							if (this.parm[j].key == item[i].key) {
								this.parm[j].val = item[i].val;
								break;
							}
						}
					}
				}
			},
			dataclear: function() {
				this.bak_data = ''; //防止重复操作记录
				this.title = '';
				this.action = '';
				this.row_id = '';
				this.sel_item = {}; //备份点击项目

				this.parm = []; //参数结构
				this.parm_th = []; //标题
			},
			fun_upd: function(type) {
				console.log('操作=' + type);
				if (type == '_add') {
					if (this.parm[0].val == '') {
						this.$message({
							message: this.parm[0].name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				} else {
					if (Number(this.row_id) == 0) {
						this.$message({
							message: '没有选择操作对象!',
							type: 'warning'
						});
						return;
					}
				}


				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					d.push(this.parm[i].val);
				}
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('data_' + this.action + type, this.row_id, this.sys_date, d);
				if (this.bak_data == temp_data) {
					this.$message({
						message: '不能重复操作!',
						type: 'warning'
					});
					return;
				}
				this.upd_json = temp_data;
				this.bak_data = temp_data;
			}


		}
	};
</script>


<style scoped>

</style>
